import { Image } from 'expo-image';
import React from 'react';
import { View } from 'react-native';

// Map storing the asset module references from require().
// The PNGs are generated from the SVG sources in assets/flags/ by
// scripts/generate-flag-pngs.mjs — to change a flag, edit the SVG,
// re-run the script, and commit both. (Rendering the SVGs directly is
// what made Android people lists stall; see the script header.)
const flagAssetMap: Record<string, number> = {
  ad: require('@/assets/flags-png/ad.png'),
  ae: require('@/assets/flags-png/ae.png'),
  af: require('@/assets/flags-png/af.png'),
  ag: require('@/assets/flags-png/ag.png'),
  ai: require('@/assets/flags-png/ai.png'),
  al: require('@/assets/flags-png/al.png'),
  am: require('@/assets/flags-png/am.png'),
  an: require('@/assets/flags-png/an.png'),
  ao: require('@/assets/flags-png/ao.png'),
  aq: require('@/assets/flags-png/aq.png'), 
  ar: require('@/assets/flags-png/ar.png'),
  as: require('@/assets/flags-png/as.png'),
  at: require('@/assets/flags-png/at.png'),
  au: require('@/assets/flags-png/au.png'), 
  ax: require('@/assets/flags-png/ax.png'),
  az: require('@/assets/flags-png/az.png'),
  ba: require('@/assets/flags-png/ba.png'),
  bb: require('@/assets/flags-png/bb.png'),
  bd: require('@/assets/flags-png/bd.png'),
  be: require('@/assets/flags-png/be.png'),
  bf: require('@/assets/flags-png/bf.png'),
  bg: require('@/assets/flags-png/bg.png'),
  bh: require('@/assets/flags-png/bh.png'),
  bi: require('@/assets/flags-png/bi.png'),
  bj: require('@/assets/flags-png/bj.png'),
  bl: require('@/assets/flags-png/bl.png'),
  bm: require('@/assets/flags-png/bm.png'),
  bn: require('@/assets/flags-png/bn.png'),
  bo: require('@/assets/flags-png/bo.png'),
  br: require('@/assets/flags-png/br.png'),
  bs: require('@/assets/flags-png/bs.png'),
  bt: require('@/assets/flags-png/bt.png'),
  bw: require('@/assets/flags-png/bw.png'),
  by: require('@/assets/flags-png/by.png'),
  bz: require('@/assets/flags-png/bz.png'),
  ca: require('@/assets/flags-png/ca.png'),
  cc: require('@/assets/flags-png/cc.png'),
  cd: require('@/assets/flags-png/cd.png'),
  cf: require('@/assets/flags-png/cf.png'),
  cg: require('@/assets/flags-png/cg.png'),
  ch: require('@/assets/flags-png/ch.png'),
  ci: require('@/assets/flags-png/ci.png'),
  ck: require('@/assets/flags-png/ck.png'),
  cl: require('@/assets/flags-png/cl.png'),
  cm: require('@/assets/flags-png/cm.png'),
  cn: require('@/assets/flags-png/cn.png'),
  co: require('@/assets/flags-png/co.png'),
  cq: require('@/assets/flags-png/cq.png'),
  cr: require('@/assets/flags-png/cr.png'),
  cu: require('@/assets/flags-png/cu.png'),
  cv: require('@/assets/flags-png/cv.png'),
  cw: require('@/assets/flags-png/cw.png'),
  cx: require('@/assets/flags-png/cx.png'),
  cy: require('@/assets/flags-png/cy.png'),
  cz: require('@/assets/flags-png/cz.png'),
  de: require('@/assets/flags-png/de.png'),
  dj: require('@/assets/flags-png/dj.png'),
  dk: require('@/assets/flags-png/dk.png'),
  dm: require('@/assets/flags-png/dm.png'),
  do: require('@/assets/flags-png/do.png'),
  dz: require('@/assets/flags-png/dz.png'),
  ec: require('@/assets/flags-png/ec.png'),
  ee: require('@/assets/flags-png/ee.png'),
  eg: require('@/assets/flags-png/eg.png'),
  eh: require('@/assets/flags-png/eh.png'),
  er: require('@/assets/flags-png/er.png'),
  es: require('@/assets/flags-png/es.png'),
  et: require('@/assets/flags-png/et.png'),
  fi: require('@/assets/flags-png/fi.png'),
  fj: require('@/assets/flags-png/fj.png'),
  fk: require('@/assets/flags-png/fk.png'),
  fm: require('@/assets/flags-png/fm.png'),
  fo: require('@/assets/flags-png/fo.png'),
  fr: require('@/assets/flags-png/fr.png'),
  ga: require('@/assets/flags-png/ga.png'),
  gb: require('@/assets/flags-png/gb.png'),
  gd: require('@/assets/flags-png/gd.png'),
  ge: require('@/assets/flags-png/ge.png'),
  gf: require('@/assets/flags-png/gf.png'),
  gg: require('@/assets/flags-png/gg.png'),
  gh: require('@/assets/flags-png/gh.png'),
  gi: require('@/assets/flags-png/gi.png'),
  gl: require('@/assets/flags-png/gl.png'),
  gm: require('@/assets/flags-png/gm.png'),
  gn: require('@/assets/flags-png/gn.png'),
  gp: require('@/assets/flags-png/gp.png'),
  gq: require('@/assets/flags-png/gq.png'),
  gr: require('@/assets/flags-png/gr.png'),
  gs: require('@/assets/flags-png/gs.png'),
  gt: require('@/assets/flags-png/gt.png'),
  gu: require('@/assets/flags-png/gu.png'),
  gw: require('@/assets/flags-png/gw.png'),
  gy: require('@/assets/flags-png/gy.png'),
  hk: require('@/assets/flags-png/hk.png'),
  hn: require('@/assets/flags-png/hn.png'),
  hr: require('@/assets/flags-png/hr.png'),
  ht: require('@/assets/flags-png/ht.png'),
  hu: require('@/assets/flags-png/hu.png'),
  id: require('@/assets/flags-png/id.png'),
  ie: require('@/assets/flags-png/ie.png'),
  il: require('@/assets/flags-png/il.png'),
  im: require('@/assets/flags-png/im.png'),
  in: require('@/assets/flags-png/in.png'),
  io: require('@/assets/flags-png/io.png'),
  iq: require('@/assets/flags-png/iq.png'),
  ir: require('@/assets/flags-png/ir.png'),
  is: require('@/assets/flags-png/is.png'),
  it: require('@/assets/flags-png/it.png'),
  je: require('@/assets/flags-png/je.png'),
  jm: require('@/assets/flags-png/jm.png'),
  jo: require('@/assets/flags-png/jo.png'),
  jp: require('@/assets/flags-png/jp.png'),
  ke: require('@/assets/flags-png/ke.png'),
  kg: require('@/assets/flags-png/kg.png'),
  kh: require('@/assets/flags-png/kh.png'),
  ki: require('@/assets/flags-png/ki.png'),
  km: require('@/assets/flags-png/km.png'),
  kn: require('@/assets/flags-png/kn.png'),
  kp: require('@/assets/flags-png/kp.png'),
  kr: require('@/assets/flags-png/kr.png'),
  kw: require('@/assets/flags-png/kw.png'),
  ky: require('@/assets/flags-png/ky.png'),
  kz: require('@/assets/flags-png/kz.png'),
  la: require('@/assets/flags-png/la.png'),
  lb: require('@/assets/flags-png/lb.png'),
  lc: require('@/assets/flags-png/lc.png'),
  li: require('@/assets/flags-png/li.png'),
  lk: require('@/assets/flags-png/lk.png'),
  lr: require('@/assets/flags-png/lr.png'),
  ls: require('@/assets/flags-png/ls.png'),
  lt: require('@/assets/flags-png/lt.png'),
  lu: require('@/assets/flags-png/lu.png'),
  lv: require('@/assets/flags-png/lv.png'),
  ly: require('@/assets/flags-png/ly.png'),
  ma: require('@/assets/flags-png/ma.png'),
  mc: require('@/assets/flags-png/mc.png'),
  md: require('@/assets/flags-png/md.png'),
  me: require('@/assets/flags-png/me.png'),
  mf: require('@/assets/flags-png/mf.png'),
  mg: require('@/assets/flags-png/mg.png'),
  mh: require('@/assets/flags-png/mh.png'),
  mk: require('@/assets/flags-png/mk.png'),
  ml: require('@/assets/flags-png/ml.png'),
  mm: require('@/assets/flags-png/mm.png'),
  mn: require('@/assets/flags-png/mn.png'),
  mo: require('@/assets/flags-png/mo.png'),
  mp: require('@/assets/flags-png/mp.png'),
  mq: require('@/assets/flags-png/mq.png'),
  mr: require('@/assets/flags-png/mr.png'),
  ms: require('@/assets/flags-png/ms.png'),
  mt: require('@/assets/flags-png/mt.png'),
  mu: require('@/assets/flags-png/mu.png'),
  mv: require('@/assets/flags-png/mv.png'),
  mw: require('@/assets/flags-png/mw.png'),
  mx: require('@/assets/flags-png/mx.png'),
  my: require('@/assets/flags-png/my.png'),
  mz: require('@/assets/flags-png/mz.png'),
  na: require('@/assets/flags-png/na.png'),
  nc: require('@/assets/flags-png/nc.png'),
  ne: require('@/assets/flags-png/ne.png'),
  nf: require('@/assets/flags-png/nf.png'),
  ng: require('@/assets/flags-png/ng.png'),
  ni: require('@/assets/flags-png/ni.png'),
  nl: require('@/assets/flags-png/nl.png'),
  no: require('@/assets/flags-png/no.png'),
  np: require('@/assets/flags-png/np.png'),
  nr: require('@/assets/flags-png/nr.png'),
  nu: require('@/assets/flags-png/nu.png'),
  nz: require('@/assets/flags-png/nz.png'),
  om: require('@/assets/flags-png/om.png'),
  pa: require('@/assets/flags-png/pa.png'),
  pe: require('@/assets/flags-png/pe.png'),
  pf: require('@/assets/flags-png/pf.png'),
  pg: require('@/assets/flags-png/pg.png'),
  ph: require('@/assets/flags-png/ph.png'),
  pk: require('@/assets/flags-png/pk.png'),
  pl: require('@/assets/flags-png/pl.png'),
  pm: require('@/assets/flags-png/pm.png'),
  pn: require('@/assets/flags-png/pn.png'),
  pr: require('@/assets/flags-png/pr.png'),
  ps: require('@/assets/flags-png/ps.png'),
  pt: require('@/assets/flags-png/pt.png'),
  pw: require('@/assets/flags-png/pw.png'),
  py: require('@/assets/flags-png/py.png'),
  qa: require('@/assets/flags-png/qa.png'),
  re: require('@/assets/flags-png/re.png'),
  ro: require('@/assets/flags-png/ro.png'),
  rs: require('@/assets/flags-png/rs.png'),
  ru: require('@/assets/flags-png/ru.png'),
  rw: require('@/assets/flags-png/rw.png'),
  sa: require('@/assets/flags-png/sa.png'),
  sb: require('@/assets/flags-png/sb.png'),
  sc: require('@/assets/flags-png/sc.png'),
  sd: require('@/assets/flags-png/sd.png'),
  se: require('@/assets/flags-png/se.png'),
  sg: require('@/assets/flags-png/sg.png'),
  si: require('@/assets/flags-png/si.png'),
  sk: require('@/assets/flags-png/sk.png'),
  sl: require('@/assets/flags-png/sl.png'),
  sm: require('@/assets/flags-png/sm.png'),
  sn: require('@/assets/flags-png/sn.png'),
  so: require('@/assets/flags-png/so.png'),
  sr: require('@/assets/flags-png/sr.png'),
  ss: require('@/assets/flags-png/ss.png'),
  st: require('@/assets/flags-png/st.png'),
  sv: require('@/assets/flags-png/sv.png'),
  sx: require('@/assets/flags-png/sx.png'),
  sy: require('@/assets/flags-png/sy.png'),
  sz: require('@/assets/flags-png/sz.png'),
  tc: require('@/assets/flags-png/tc.png'),
  td: require('@/assets/flags-png/td.png'),
  tf: require('@/assets/flags-png/tf.png'),
  tg: require('@/assets/flags-png/tg.png'),
  th: require('@/assets/flags-png/th.png'),
  tj: require('@/assets/flags-png/tj.png'),
  tk: require('@/assets/flags-png/tk.png'),
  tl: require('@/assets/flags-png/tl.png'),
  tm: require('@/assets/flags-png/tm.png'),
  tn: require('@/assets/flags-png/tn.png'),
  to: require('@/assets/flags-png/to.png'),
  tr: require('@/assets/flags-png/tr.png'),
  tt: require('@/assets/flags-png/tt.png'),
  tv: require('@/assets/flags-png/tv.png'),
  tw: require('@/assets/flags-png/tw.png'),
  tz: require('@/assets/flags-png/tz.png'),
  ua: require('@/assets/flags-png/ua.png'),
  ug: require('@/assets/flags-png/ug.png'),
  us: require('@/assets/flags-png/us.png'),
  uy: require('@/assets/flags-png/uy.png'),
  uz: require('@/assets/flags-png/uz.png'),
  va: require('@/assets/flags-png/va.png'),
  vc: require('@/assets/flags-png/vc.png'),
  ve: require('@/assets/flags-png/ve.png'),
  vg: require('@/assets/flags-png/vg.png'),
  vi: require('@/assets/flags-png/vi.png'),
  vn: require('@/assets/flags-png/vn.png'),
  vu: require('@/assets/flags-png/vu.png'),
  wf: require('@/assets/flags-png/wf.png'),
  ws: require('@/assets/flags-png/ws.png'),
  xk: require('@/assets/flags-png/xk.png'),
  xx: require('@/assets/flags-png/xx.png'), // Placeholder
  ye: require('@/assets/flags-png/ye.png'),
  yt: require('@/assets/flags-png/yt.png'),
  yu: require('@/assets/flags-png/yu.png'),
  za: require('@/assets/flags-png/za.png'),
  zm: require('@/assets/flags-png/zm.png'),
  zw: require('@/assets/flags-png/zw.png'),
};

interface ICountryFlagIconProps {
  /**
   * The country code corresponding to the flag filename stem in circle-flags.
   * e.g., 'us', 'gb', 'fr', etc.
   */
  countryCode: string;
  /**
   * Size of the flag icon in pixels (e.g., 16, 20, 24, 32, 48)
   * Will be applied as width and height style values
   */
  size?: number;
  /**
   * NativeWind className for additional styling.
   */
  className?: string;
}

// Flags render through expo-image straight from the bundled SVG asset: one
// native view per flag, rasterized off the main thread. The previous SvgXml
// approach mounted a native node per SVG element (~20 per flag), which made a
// page of member cards a main-thread mount storm on Android, and needed an
// async FileSystem/XML-string pipeline besides.
const CountryFlagIconComponent: React.FC<ICountryFlagIconProps> = ({
  countryCode,
  className,
  size,
  ...props
}) => {
  const code = countryCode?.toLowerCase() || null;
  const assetModule = code ? flagAssetMap[code] : undefined;

  if (!assetModule) {
    // Render an empty view with the given className to maintain layout
    // when there is no flag for the code (or no code at all).
    return (
      <View className={className} style={size ? { width: size, height: size } : undefined} {...props} />
    );
  }

  return (
    <View className={className} style={size ? { width: size, height: size } : undefined} {...props}>
      <Image source={assetModule} style={{ width: '100%', height: '100%' }} contentFit="cover" />
    </View>
  );
};

// Memoized: rendered inside every member card, so parent list re-renders
// must not re-diff the flag subtree.
const CountryFlagIcon = React.memo(CountryFlagIconComponent);

export { CountryFlagIcon };
